import styled from 'styled-components';
import { Text, fontSize, palette, spacing } from '@landr/maestro';

export const CardTitle = styled(Text)`
    max-width: 100%;

    font-size: ${fontSize('sm')};
    color: ${palette('neutral.50')};
    margin-top: ${spacing(3)};
    display: block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    line-height: normal;
    position: relative;
`;

export const CardTitleCentered = styled(CardTitle)`
    text-align: center;
`;
